import React from "react";
import { useState } from "react";
import EmployeeInfo from "../Cards/EmployeeInfo";
import ApprovalStatus from "./Components/approvalStatus";
import ViewApproval from "./ViewApproval";
import moment from "moment";
import { TbBed, TbBus, TbCar, TbMap, TbPlane, TbReceipt, TbTrain } from "react-icons/tb";
import { useClientSettings } from "Hooks/useClientSettings";

function Approvals({ id, status, amount, type, date, trail, inSequence, violations, requestor, approvers, onReload = () => {}, readOnly }) {
	const { currency } = useClientSettings();

	const [OpenId, setOpenId] = useState();
	const ICONS = {
		trip: <TbMap />,
		receipt: <TbReceipt />,
		flight: <TbPlane />,
		bus: <TbBus />,
		stay: <TbBed />,
		train: <TbTrain />,
		cab: <TbCar />,
	};

	return (
		<>
			<div onClick={() => setOpenId(id)} className="overflow-hidden border shadow-sm cursor-pointer rounded-xl bg-canvas min-w-min hover:bg-light">
				<div className="p-4">
					<div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
						<div className="min-w-0 align-center gap-x-2">
							{ICONS[type]}
							<h4 className="capitalize truncate">
								{type} - {currency} {amount}
							</h4>
						</div>
						<div className="text-label whitespace-nowrap">{moment(date).format("DD MMM YYYY")}</div>
					</div>
					<EmployeeInfo size="sm" className="!p-0 mt-3" employee={requestor} />
				</div>
				{status && <ApprovalStatus status={status} id={`APP-${id}`} trail={trail} inSequence={inSequence} />}
			</div>
			<ViewApproval readOnly={readOnly} approvalId={OpenId} onClose={() => setOpenId()} onReload={onReload} />
		</>
	);
}

export default Approvals;
